// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010404/js/" + chunkId + "." + {"44":"facebd66","225":"9d664b2c","481":"62fee7a9","486":"40f98e2a","770":"ce40261b"}[chunkId] + ".0.1733696324693128.chunk.js";
};